import React from 'react';
import {DefaultRootState, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {DocumentAssistantComponent} from './documentAssistantComponent';

export const DocumentAssistantPage = React.memo(() => {
    const documentAssistantConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.aiAssistant.allDocsAssistant);
    const navigate = useNavigate();
    if (!documentAssistantConfig.enabled) {
        navigate('/');
    }

    return <DocumentAssistantComponent />;
});
